import React from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

export const SaveCancel = (props) => {
  const { cancelCall, saveCall } = props;
  return (
    <div>
      <Stack direction="row" spacing={2}>
        <Button size="md" variant="contained" onClick={cancelCall}>
          Cancel
        </Button>
        <Button size="md" variant="contained" onClick={saveCall}>
          Save
        </Button>
      </Stack>
    </div>
  );
};
